module.exports = __webpack_public_path__ + "static/img/20141127-20150322.dbf984b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20141127-20150322.png
// module id = n7mg
// module chunks = 1